import * as React from "react";
import ReactTooltip from 'react-tooltip';

import "./customization-tab.scss";

import {cst, cstAssign}          from "@Common/react/chain-services";
import {consumeContext}          from "@Common/react/context";
import {scopedState}             from "@Common/react/scoped-state";
import {Types}                   from "@Common/types";
import {Responsive}              from "@Common/ui-components/responsive";
import {oMapToArr}               from "@Common/utils/objects";
import {FloatingInput}           from "@Xpresso/routes/account/common/floating-labels/floating-input";
import {ModalLayout}             from "@Xpresso/routes/common/modal-layout/modal-layout";

import {UserCreateTabs,
        goToPreviousTab, 
        goToNextTab,
        controlInput}                 from "../../user-create-tabs";

interface VarStack {
    company    : any,
    customizationData : any[],
    responsive  : any,
}

export const CustomizationTab = ({step, agent}) : ({
    step: Types.Common.React.UseState.UseStateNext<number>, 
    modal: Types.Common.UiComponents.ModalService3.ModalService3RootNext<void>, 
    agent: Types.Common.React.UseState.UseStateNext<string>,
}) => cst<VarStack>(
    consumeContext("company"),
    cstAssign("customizationData", ({company}, next) => next(parseAgentDisplayData({company}))),
    cstAssign("responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>),
    ({responsive}, next) => (
        ModalLayout({
            title: "Create New User",
            content: (
                <>
                    {responsive.ge("md") && UserCreateTabs({step})}
                    {next()}
                </>
            ),
            buttons: [
                {
                    label: "Back",
                    onClick: () => goToPreviousTab(step),
                },
                {
                    label: "Next",
                    primary: true,
                    disabled: missingRequiredData({agent}),
                    onClick: () => goToNextTab(step),
                },
            ]
        })
    ),
    ({customizationData}) => (
        <div className="customization-tab-s8i">
            {customizationData.map((datum, i) => {
                const props = {
                    value: scopedState(agent, ['inputs', datum.mapping]).value || controlInput,
                    onChange: (e) => {
                        let value = e.target.value; 
                        scopedState(agent, ['errors', datum.mapping]).onChange(false);
                        scopedState(agent, ['inputs', datum.mapping]).onChange(value);
                    },
                    className: "value",
                    maxLength: datum?.maxLength,
                    "xd-qa-type": "textbox",
                    "xd-qa-name": datum.label,
                }
                return(
                    <React.Fragment key={i}>
                        <FloatingInput
                            classContainer="input-card"
                            classLabel="label"
                            textLabel={datum.label}
                            props={props}
                        />
                        {scopedState(agent, ['errors', datum.mapping]).value && (
                            <div className="errorMessage">
                                {scopedState(agent, ['errors', datum.mapping]).value}
                            </div>
                        )}
                    </React.Fragment>
                )
            })}
        </div>
    )
);

const missingRequiredData = ({agent}) => {
    return !!scopedState(agent, ['errors', "agentDisplay1"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay2"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay3"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay4"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay5"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay6"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay7"]).value ||
    !!scopedState(agent, ['errors', "agentDisplay8"]).value 
}

export const parseAgentDisplayData = ({company}) => {
    return oMapToArr(company.displayFields, (displayField, lineNumber) => {
        return {"label": displayField, "value": "", "mapping": "agentDisplay" + lineNumber, "maxLength": parseInt(lineNumber) >= 7 ? 80 : 50 }
    });
};